import { configureStore } from '@reduxjs/toolkit';
import authReducer           from './slices/authSlice';
import clientsReducer        from './slices/clientsSlice';
import coachingsReducer      from './slices/coachingsSlice';
import dashboardReducer      from './slices/dashboardSlice';
import notificationsReducer  from './slices/notificationsSlice';
import utilisateursReducer   from './slices/utilisateursSlice';
import formationsReducer     from './slices/formationsSlice';
import auditReducer          from './slices/auditSlice';

export const store = configureStore({
  reducer: {
    auth:           authReducer,
    clients:        clientsReducer,
    coachings:      coachingsReducer,
    dashboard:      dashboardReducer,
    notifications:  notificationsReducer,
    utilisateurs:   utilisateursReducer,
    formations:     formationsReducer,
    audit:          auditReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});
